"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.videoPropType = exports.linkCtaPropType = exports.imagePropType = exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = require("@mmc/text");

var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});

exports.imagePropType = imagePropType;

var videoPropType = _propTypes["default"].shape({
  youtubeVideoId: _propTypes["default"].string,
  source: _propTypes["default"].string
});

exports.videoPropType = videoPropType;

var linkCtaPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string,
  priority: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool
});

exports.linkCtaPropType = linkCtaPropType;

var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  heading1: _propTypes["default"].string,
  heading2: _propTypes["default"].string,
  textBlock: _propTypes["default"].string,
  cta: linkCtaPropType,
  image: imagePropType,
  textBlockPosition: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  video: videoPropType,
  disclaimerData: _text.disclaimerDataPropTypes
});

var _default = PROP_TYPES;
exports["default"] = _default;